import React, { useCallback, useEffect, useState } from 'react';
import css from '../../components/form/elements/button.module.css';
import { useService } from '../../services/services';
import { useHistory } from 'react-router';
import { route } from '../../services/utils';
import { DASHBOARD, TOKENS_VIEW } from '../../router/routes';
import Token from '../../interfaces/token';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addNotice } from '../../store/global-slice';

export default function ApiTokenCreateApp({
  name,
  returnUrl,
  method,
}: {
  name: string;
  returnUrl: string;
  method: string;
}) {
  const { tokenService } = useService();
  const history = useHistory();

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [appDoesNotExist, setAppDoesNotExist] = useState<boolean>(false);

  useEffect(() => {
    const subscription = tokenService.exists(name).subscribe(
      (token: Token) => {
        dispatch(
          addNotice({
            accessor: 'TokenErrors',
            status: 'error',
            description: t('The token name has already been taken!'),
          })
        );
        history.push(route(TOKENS_VIEW, { id: token.id }));
      },
      (errorResponse) => {
        if (errorResponse.status === 404) {
          setAppDoesNotExist(true);
        }
      }
    );
    return () => subscription.unsubscribe();
  }, [tokenService, name, dispatch, history, t]);

  const createCallback = useCallback(() => {
    tokenService.store({ name } as Token).subscribe((response) => {
      if (method && method.toLowerCase() === 'post') {
        const token = document.createElement('input');
        token.name = 'token';
        token.value = response.plainTextToken;

        const form = document.createElement('form');
        form.method = 'post';
        form.action = returnUrl;
        form.appendChild(token);

        document.body.appendChild(form);
        form.submit();
      } else {
        const url = new URL(returnUrl);
        const searchParams = url.searchParams;
        searchParams.append('token', response.plainTextToken);
        url.search = searchParams.toString();

        window.location.assign(url.toString());
      }
    });
  }, [name, method, returnUrl, tokenService]);

  const cancelCallback = useCallback(() => {
    if (document.referrer) {
      window.location.assign(document.referrer);
    } else {
      history.push({ pathname: route(DASHBOARD) });
    }
  }, [history]);

  return (
    <>
      {appDoesNotExist && (
        <div className="max-w-xl mx-auto">
          <div className="bg-white shadow-md rounded-lg max-w-md mb-5">
            <div className="p-5 flex flex-col">
              <div>
                <h5 className="text-gray-900 font-bold text-2xl tracking-tight mb-2">
                  {name}
                </h5>
              </div>
              <p className="font-normal text-gray-700 mb-3">
                Dot piekļuvi "{name}" veikt darbības jūsu vietā
              </p>
              <div className="flex justify-between">
                <button
                  name="token_cancel"
                  className={`${css['button']}`}
                  type="button"
                  onClick={cancelCallback}
                >
                  <span>{t('no')}</span>
                </button>
                <button
                  name="token_accept"
                  className={`${css['button']} ${css['primary']}`}
                  type="button"
                  onClick={createCallback}
                >
                  <span>{t('yes')}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
